import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";
import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/StakingRTrava.json";
import { web3Reader } from "src/wallet-connection";

const { STAKING_R_TRAVA_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, STAKING_R_TRAVA_ADDRESS);
  }
  return contractReader;
}

async function balanceOf(accountAddress) {
  try {
    const res = await getContractReader().methods.balanceOf(accountAddress).call();
    return BigNumber(res).dividedBy(BASE18).toNumber();
  } catch (error) {
    return undefined;
  }
}

export default {
  ABI,
  ADDRESS: STAKING_R_TRAVA_ADDRESS,
  balanceOf,
};
